import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ProgressPercentageIndicator from './ProgressPercentageIndicator';
import './style.scss';

export const StatisticsAddedMaterialsStudents = ({ totalCount, addedCount, title, subTitle }) => {
  const { t } = useTranslation();

  return (
    <div className="statistics-added-materials-block">
      <div className="statistics-added-materials-block-top">
        <div className="statistics-added-materials-text">
          <span className="statistics-added-materials-count">
            {addedCount} {t(title)}
          </span>
          <span className="statistics-added-materials-count-text">{t(subTitle)}</span>
        </div>
      </div>

      <ProgressPercentageIndicator totalMaterials={totalCount} sentMaterials={addedCount} />

      <div className="statistics-added-materials-info">
        <div className="statistics-added-materials-info-item">
          <div className="color-item"></div>

          <div className="text-item">
            <p>{t('all materials')}</p>
          </div>
        </div>

        <div className="statistics-added-materials-info-item">
          <div className="color-item"></div>

          <div className="text-item">
            <p>{t('sent materials')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
